/**
 * 权利要求树节点权限策略
 * @module claim-tree-node-strategy
 */

import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type {
    FeaturePermissionStrategy,
    FeaturePermissionContext,
    PermissionCheckResult,
    FeatureKey,
} from '@telecom/shared/domain/permission';

/**
 * 权利要求树节点权限策略
 */
@injectable()
export class ClaimTreeNodeStrategy implements FeaturePermissionStrategy {
    readonly featureId: FeatureKey = '查新:添加权利要求树节点';

    async checkPermission(context: FeaturePermissionContext): Promise<PermissionCheckResult> {
        const { featureId, permissionService } = context;
        const planType = permissionService.getUserPlan()?.planType;

        if (planType === 'free') {
            // 检查配额
            if (!permissionService.hasQuota(featureId)) {
                return {
                    granted: false,
                    reason: 'quota_exceeded',
                    suggestedAction: 'upgrade_to_pro',
                    message: '付款，升级 Pro',
                };
            }
        }

        return {
            granted: true,
        };
    }

    async recordUsage(context: FeaturePermissionContext): Promise<void> {
        console.log('[权利要求树] 使用量已记录', context.featureId);
        // 实际的使用量记录逻辑
        // 可能需要调用 API 记录使用量
    }
}
